import { render, staticRenderFns } from "./log_view.vue?vue&type=template&id=6b8dcc86"
import script from "./log_view.vue?vue&type=script&lang=js"
export * from "./log_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8dcc86')) {
      api.createRecord('6b8dcc86', component.options)
    } else {
      api.reload('6b8dcc86', component.options)
    }
    module.hot.accept("./log_view.vue?vue&type=template&id=6b8dcc86", function () {
      api.rerender('6b8dcc86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/log_view/log_view.vue"
export default component.exports